import { render, staticRenderFns } from "./FeedView.vue?vue&type=template&id=28e472ca&scoped=true"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"
import style0 from "./FeedView.vue?vue&type=style&index=0&id=28e472ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e472ca",
  null
  
)

export default component.exports